export default "__VITE_ASSET__niu282Oq__"